// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

function h2(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.fontWeight("normal"),
              BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(0.5)),
              BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(1.0)),
              BsCssJs$PrezzeeRibbon.color(match.downloadAppsBanner.color),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(1.625))]),
              BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
                    BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.125)),
                    BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1.75)),
                    BsCssJs$PrezzeeRibbon.textAlign("center")
                  ]),
              BsCssJs$PrezzeeRibbon.selector("strong", [BsCssJs$PrezzeeRibbon.fontWeight("semiBold")])
            ]);
}

var Styles = {
  h2: h2
};

function DownloadAppsBanner__SubHeading(props) {
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx("h2", {
              children: props.children,
              className: Classnames([
                    Theme__Typography$PrezzeeRibbon.Styles.h5,
                    h2(theme)
                  ])
            });
}

var make = DownloadAppsBanner__SubHeading;

export {
  Styles ,
  make ,
}
/* classnames Not a pure module */
